import { useContext } from "react";
import { LocationContext } from "context/Location";
import { useAuth } from "hooks/useAuth";

/**
 * useClinicPending — true when the signed-in facility owner created a brand-new
 * clinic during signup that is still awaiting admin approval (locations.status
 * === "pending"). The clinic is empty (no PHI) and hidden from the patient map
 * until approved, so the owner is let into the dashboard to pre-configure it
 * while a persistent banner reminds them it isn't live yet.
 *
 * Single source of truth shared by the banner (StatusBanner), the layout space
 * it reserves (DashboardNav), and the onboarding card it displaces
 * (FacilityChecklist), so they can't drift apart.
 */
export const useClinicPending = () => {
  const { userData } = useAuth();
  const { location } = useContext(LocationContext);
  return userData?.role === "facility" && location?.status === "pending";
};
